import Icon from '@/components/ui/AppIcon';

interface Service {
  id: string;
  name: string;
  icon: string;
}

interface ServiceSelectorProps {
  selectedServices: string[];
  onToggle: (serviceId: string) => void;
}

const ServiceSelector = ({ selectedServices, onToggle }: ServiceSelectorProps) => {
  const services: Service[] = [
    { id: 'plumbing', name: 'Plomberie', icon: 'WrenchScrewdriverIcon' },
    { id: 'electrical', name: 'Électricité', icon: 'BoltIcon' },
    { id: 'painting', name: 'Peinture', icon: 'PaintBrushIcon' },
    { id: 'flooring', name: 'Revêtement de sol', icon: 'Square3Stack3DIcon' },
    { id: 'carpentry', name: 'Menuiserie', icon: 'CubeIcon' },
    { id: 'insulation', name: 'Isolation', icon: 'ShieldCheckIcon' },
    { id: 'hvac', name: 'Chauffage/Climatisation', icon: 'FireIcon' },
    { id: 'energy', name: 'Solutions Énergétiques', icon: 'LightBulbIcon' },
  ];

  return (
    <div data-component-id="src/app/contact-quote/components/ServiceSelector.tsx:27:4" data-component-path="src/app/contact-quote/components/ServiceSelector.tsx" data-component-line="27" data-component-end-line="54" data-component-file="ServiceSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-5%20gap-3%22%7D" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
      {services.map((service) => {
        const isSelected = selectedServices.includes(service.id);
        return (
          <button data-component-id="src/app/contact-quote/components/ServiceSelector.tsx:31:10" data-component-path="src/app/contact-quote/components/ServiceSelector.tsx" data-component-line="31" data-component-end-line="51" data-component-file="ServiceSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
            key={service.id}
            type="button"
            onClick={() => onToggle(service.id)}
            className={`p-4 rounded-lg border-2 transition-all duration-300 flex flex-col items-center space-y-2 ${
              isSelected
                ? 'border-primary bg-light-accent shadow-gold'
                : 'border-border bg-card hover:border-primary-light hover:shadow-subtle'
            }`}
          >
            <div data-component-id="src/app/contact-quote/components/ServiceSelector.tsx:41:12" data-component-path="src/app/contact-quote/components/ServiceSelector.tsx" data-component-line="41" data-component-end-line="47" data-component-file="ServiceSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`p-2 rounded-lg ${
                isSelected ? 'bg-primary text-primary-foreground' : 'bg-muted text-secondary'
              }`}
            >
              <Icon data-component-id="src/app/contact-quote/components/ServiceSelector.tsx:46:14" data-component-path="src/app/contact-quote/components/ServiceSelector.tsx" data-component-line="46" data-component-end-line="46" data-component-file="ServiceSelector.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={service.icon as any} size={20} />
            </div>
            <span data-component-id="src/app/contact-quote/components/ServiceSelector.tsx:48:12" data-component-path="src/app/contact-quote/components/ServiceSelector.tsx" data-component-line="48" data-component-end-line="50" data-component-file="ServiceSelector.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`text-xs font-semibold text-center ${isSelected ? 'text-primary' : 'text-text-secondary'}`}>
              {service.name}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ServiceSelector;